import styled from 'styled-components';
import { FontSizes } from '../../../common/typography/typography.styles';
import { SelectContainer } from '../../../common/select/select.styles';

export const HeaderSettingsPopupContainer = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 20px;
  background-color: #fff;
  padding: 2.4rem;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.baseColors.grey25};
  box-shadow: 0 2px 8px 0 #05236b14;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 36rem;

  h3 {
    font-size: ${FontSizes.medium};
    color: ${({ theme }) => theme.colors.baseColors.grey150};
  }

  ${SelectContainer} {
    width: 100%;

    label {
      display: block;
      font-size: ${FontSizes.normal};
      color: ${({ theme }) => theme.colors.baseColors.grey100};
      font-weight: 500;
      margin-bottom: 4px;
    }
  }
`;

export const HeaderOptionsButton = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  border-radius: 10px;
  transition: 0.3s all ease;
  position: relative;

  &:hover {
    background-color: ${({ theme }) => theme.colors.baseColors.grey5};
  }

  svg {
    display: block;
    width: 20px;
    height: 20px;
  }

  .divider {
    padding: 0;
    width: 1px;
    height: 20px;
    background-color: ${({ theme }) => theme.colors.baseColors.grey50};
  }
`;

export const ValueHolder = styled.div`
    font-size: ${FontSizes.normal};
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px;
    color: ${({ theme }) => theme.colors.baseColors.grey150};
    text-underline-offset
`;

export const RegionSettingsTitle = styled.h2`
  font-size: ${FontSizes.mediumPlus};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.baseColors.grey150};
`;
